import { Card, SelectOptionGroups, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { TrainingWizardData } from '../NewTrainingWizard/types'
import { BasicInfoFormValues } from '../TrainingEditMode/types'

type Props = {
  data: TrainingWizardData | BasicInfoFormValues
  onChange: (value: TrainingWizardData | BasicInfoFormValues) => void
  open: boolean
  setOpen?: (value: boolean) => void
}
export const CourseValidity = ({ open, onChange, data, setOpen }: Props) => {
  const options: SelectOptionGroups = Array.from({ length: 10 }, (_, index) => {
    const value = index + 1
    return {
      label: i18n.tp(
        'trainings.trainings_revamp.new_training.wizard.basic_information.course_validity.year_info',
        { count: value }
      ),
      value: value,
    }
  })

  const onOpen = (value: boolean) => {
    if (setOpen) setOpen(value)
    onChange({ ...data, validFor: value ? 1 : undefined })
  }

  return (
    <Card>
      <Card.Title
        size="small"
        action={<TogglerCheckbox value={open} onChange={onOpen} disabled={false} />}
      >
        {i18n.t(
          'trainings.trainings_revamp.new_training.wizard.basic_information.course_validity.title'
        )}
      </Card.Title>
      <Card.Description>
        {i18n.t(
          'trainings.trainings_revamp.new_training.wizard.basic_information.course_validity.description'
        )}
      </Card.Description>
      <Card.ExpandableContent expanded={open}>
        <Select
          options={options}
          mandatory
          label={i18n.t(
            'trainings.trainings_revamp.new_training.wizard.basic_information.course_validity.label'
          )}
          defaultValue={data.validFor?.toString()}
          value={data.validFor?.toString()}
          onChange={(value) => onChange({ ...data, validFor: Number(value) })}
        />
      </Card.ExpandableContent>
    </Card>
  )
}
